import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import style from './assets/style.scss'
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;
axios.defaults.headers.common["Access-Control-Allow-Origin"] = '*';
Vue.use(VueAxios, axios)
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

const token = localStorage.getItem('token')
if(token){
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.name !== 'login'){
    if(store.getters.isLoggedIn){
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
});


new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
